
// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import { db } from "../firebase";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import { Helmet } from "react-helmet";

// // Skeleton loader card
// const JobCardSkeleton = () => (
//   <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
//     <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
//     <div className="flex justify-between items-start mb-3">
//       <div className="h-6 bg-gray-300 rounded w-3/4"></div>
//       <div className="h-5 bg-gray-300 rounded w-12"></div>
//     </div>
//     <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
//     <div className="h-3 bg-gray-300 rounded w-full mb-4"></div>
//     <div className="h-10 bg-gray-300 rounded"></div>
//   </div>
// );

// const FindJob = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [jobs, setJobs] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [locationFilter, setLocationFilter] = useState("");
//   const [categoryFilter, setCategoryFilter] = useState("");
//   const [loading, setLoading] = useState(false);

//   const jobCategories = [
//     "Technology",
//     "Marketing",
//     "Design",
//     "Finance",
//     "Sales",
//     "Human Resources",
//     "Operations",
//     "Customer Service",
//     "Healthcare",
//     "Education",
//   ];

//   // Update category filter based on URL
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const categoryFromURL = params.get("category") || "";
//     setCategoryFilter(categoryFromURL);
//   }, [location.search]);

//   // Fetch jobs from Firestore
//   useEffect(() => {
//     const fetchJobs = async () => {
//       setLoading(true);
//       try {
//         const jobsRef = collection(db, "jobs");

//         const qStatus = query(jobsRef, where("status", "==", "approved"));
//         const qApproved = query(jobsRef, where("approved", "==", true));

//         const [snapStatus, snapApproved] = await Promise.all([
//           getDocs(qStatus),
//           getDocs(qApproved),
//         ]);

//         const combinedDocs = [
//           ...snapStatus.docs,
//           ...snapApproved.docs.filter(
//             (doc) => !snapStatus.docs.some((d) => d.id === doc.id)
//           ),
//         ];

//         const jobsData = combinedDocs.map((d) => ({
//           id: d.id,
//           ...d.data(),
//         }));
// jobsData.sort((a, b) => {
//   const dateA = a.postedDate?.toDate ? a.postedDate.toDate() : new Date(a.postedDate);
//   const dateB = b.postedDate?.toDate ? b.postedDate.toDate() : new Date(b.postedDate);
//   return dateB - dateA; // descending
// });
//         setJobs(jobsData);
//       } catch (error) {
//         console.error("Error fetching approved jobs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchJobs();
//   }, []);

//   // Filter jobs based on search, location, and category
//   const filteredJobs = jobs.filter((job) => {
//     const title = (job.title || "").toLowerCase();
//     const company = (job.company || "").toLowerCase();
//     const jobLocation = job.location || "";
//     const jobCategory = job.category || "";

//     const matchesSearch =
//       title.includes(searchTerm.toLowerCase()) ||
//       company.includes(searchTerm.toLowerCase());

//     const matchesLocation =
//       locationFilter === "" || jobLocation === locationFilter;

//     const matchesCategory =
//       categoryFilter === "" || jobCategory === categoryFilter;

//     return matchesSearch && matchesLocation && matchesCategory;
//   });

//   return (
//     <>
//       <Helmet>
//         <title>Find Jobs in Delhi NCR | Browse Latest Openings</title>
//         <meta
//           name="description"
//           content="Search and apply for the latest jobs in Delhi, Noida, and Gurugram. Browse job categories and filter by company, location, or role. Start your career with JobsInDelhiNCR."
//         />
//       </Helmet>
//       <Navbar />
//       <div className="min-h-screen bg-gray-50 py-10 px-4">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6">
//             {loading ? "Loading Jobs..." : `${filteredJobs.length} Jobs Found`}
//           </h2>

//           {/* Filters */}
//           <div className="bg-white rounded-lg shadow-md p-6 mb-8">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               <input
//                 type="text"
//                 placeholder="Search by job title or company"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={locationFilter}
//                 onChange={(e) => setLocationFilter(e.target.value)}
//               >
//                 <option value="">All Locations</option>
//                 <option value="Delhi">Delhi</option>
//                 <option value="Noida">Noida</option>
//                 <option value="Gurugram">Gurugram</option>
//               </select>
//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={categoryFilter}
//                 onChange={(e) => {
//                   const selected = e.target.value;
//                   setCategoryFilter(selected);

//                   const params = new URLSearchParams(location.search);
//                   if (selected) {
//                     params.set("category", selected);
//                   } else {
//                     params.delete("category");
//                   }

//                   navigate({
//                     pathname: "/findjobs",
//                     search: params.toString(),
//                   });
//                 }}
//               >
//                 <option value="">All Categories</option>
//                 {jobCategories.map((category) => (
//                   <option key={category} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Job Cards or Skeletons */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {loading
//               ? [...Array(6)].map((_, i) => <JobCardSkeleton key={i} />)
//               : filteredJobs.map((job) => (
//                  <div
//   key={job.id}
//   className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between hover:shadow-lg transition"
// >
//   <div>
//     <p className="text-sm text-gray-500 mb-2">
//       Posted on{" "}
//       {job.postedDate
//         ? new Date(job.postedDate).toLocaleDateString("en-IN", {
//             day: "2-digit",
//             month: "short",
//             year: "numeric",
//           })
//         : "N/A"}
//     </p>

//     <div className="flex justify-between items-start mb-3">
//       <h3 className="text-xl font-semibold text-gray-800">{job.title}</h3>
//       <span className="bg-[#F5F5F5] text-red-600 text-sm px-3 py-1 rounded-full font-medium">
//         {job.location}
//       </span>
//     </div>

//     <p className="text-gray-600 font-medium">{job.company}</p>

//     <p className="text-sm text-gray-700 mb-4">
//       <span className="font-medium">Skills Required:</span> {job.requirements}
//     </p>
//   </div>

//   {/* Button always aligned bottom-right */}
//   <div className="flex justify-end mt-4">
//     <button
//       onClick={() =>
//         navigate(`/jobdetails/${job.id}`, { state: { job } })
//       }
//       className="px-4 sm:px-6 bg-[#1e6c8e] text-white py-2 text-sm rounded-lg 
//                  hover:bg-[#155a73] transition duration-300"
//     >
//       Apply Now
//     </button>
//   </div>
// </div>

//                 ))}
//           </div>

//           {!loading && filteredJobs.length === 0 && (
//             <div className="bg-white p-8 rounded-lg shadow text-center mt-8">
//               <h3 className="text-lg font-semibold mb-2 text-gray-800">
//                 No jobs found
//               </h3>
//               <p className="text-gray-500">
//                 Try changing the filters or come back later.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default FindJob;



///////////////------------search functionality ----------------///


import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

// Skeleton loader card
const JobCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
    <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
    <div className="flex justify-between items-start mb-3">
      <div className="h-6 bg-gray-300 rounded w-3/4"></div>
      <div className="h-5 bg-gray-300 rounded w-12"></div>
    </div>
    <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
    <div className="h-3 bg-gray-300 rounded w-full mb-4"></div>
    <div className="h-10 bg-gray-300 rounded"></div>
  </div>
);

const FindJob = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [jobs, setJobs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const jobCategories = [
    "Technology",
    "Marketing",
    "Design",
    "Finance",
    "Sales",
    "Human Resources",
    "Operations",
    "Customer Service",
    "Healthcare",
    "Education",
  ];

  // Update category filter based on URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryFromURL = params.get("category") || "";
    setCategoryFilter(categoryFromURL);
  }, [location.search]);

  // Fetch jobs from Firestore
  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true);
      try {
        const jobsRef = collection(db, "jobs");

        const qStatus = query(jobsRef, where("status", "==", "approved"));
        const qApproved = query(jobsRef, where("approved", "==", true));

        const [snapStatus, snapApproved] = await Promise.all([
          getDocs(qStatus),
          getDocs(qApproved),
        ]);

        const combinedDocs = [
          ...snapStatus.docs,
          ...snapApproved.docs.filter(
            (doc) => !snapStatus.docs.some((d) => d.id === doc.id)
          ),
        ];

        const jobsData = combinedDocs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        jobsData.sort((a, b) => {
          const dateA = a.postedDate?.toDate
            ? a.postedDate.toDate()
            : new Date(a.postedDate);
          const dateB = b.postedDate?.toDate
            ? b.postedDate.toDate()
            : new Date(b.postedDate);
          return dateB - dateA; // descending
        });

        setJobs(jobsData);
      } catch (error) {
        console.error("Error fetching approved jobs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  // Filter jobs based on search, location, and category
  const filteredJobs = jobs.filter((job) => {
    const title = (job.title || "").toLowerCase();
    const company = (job.company || "").toLowerCase();
    const jobLocation = job.location || "";
    const jobCategory = job.category || "";

    const matchesSearch =
      title.includes(searchTerm.toLowerCase()) ||
      company.includes(searchTerm.toLowerCase());

    // ✅ Flexible location filter (Delhi → New Delhi, Noida → Greater Noida, etc.)
    const matchesLocation =
      locationFilter === "" ||
      jobLocation.toLowerCase().includes(locationFilter.toLowerCase());

    const matchesCategory =
      categoryFilter === "" || jobCategory === categoryFilter;

    return matchesSearch && matchesLocation && matchesCategory;
  });

  return (
    <>
      <Helmet>
        <title>Find Jobs in Delhi NCR | Browse Latest Openings</title>
        <meta
          name="description"
          content="Search and apply for the latest jobs in Delhi, Noida, and Gurugram. Browse job categories and filter by company, location, or role. Start your career with JobsInDelhiNCR."
        />
      </Helmet>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-10 px-4">
        <div className="max-w-6xl mx-auto">
          {/* <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            {loading ? "Loading Jobs..." : `${filteredJobs.length} Jobs Found`}
          </h2> */}
<h2 className="text-2xl font-semibold text-gray-800 mb-6">All Jobs</h2>

          {/* Filters */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <input
                type="text"
                placeholder="Search by job title or company"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <select
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={locationFilter}
                onChange={(e) => setLocationFilter(e.target.value)}
              >
                <option value="">All Locations</option>
                <option value="Delhi">Delhi</option>
                <option value="Noida">Noida</option>
                <option value="Gurugram">Gurugram</option>
                 <option value="Faridabad">Faridabad</option>
                <option value="Ghaziabad">Ghaziabad</option>
              </select>
              <select
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={categoryFilter}
                onChange={(e) => {
                  const selected = e.target.value;
                  setCategoryFilter(selected);

                  const params = new URLSearchParams(location.search);
                  if (selected) {
                    params.set("category", selected);
                  } else {
                    params.delete("category");
                  }

                  navigate({
                    pathname: "/findjobs",
                    search: params.toString(),
                  });
                }}
              >
                <option value="">All Categories</option>
                {jobCategories.map((category) => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Job Cards or Skeletons */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {loading
              ? [...Array(6)].map((_, i) => <JobCardSkeleton key={i} />)
              : filteredJobs.map((job) => (
                  <div
                    key={job.id}
                    className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between hover:shadow-lg transition"
                  >
                    <div>
                      <p className="text-sm text-gray-500 mb-2">
                        Posted on{" "}
                        {job.postedDate
                          ? new Date(job.postedDate).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }
                            )
                          : "N/A"}
                      </p>

                      <div className="flex justify-between items-start mb-3">
                        <h3 className="text-xl font-semibold text-gray-800">
                          {job.title}
                        </h3>
                        <span className="bg-[#F5F5F5] text-red-600 text-sm px-3 py-1 rounded-full font-medium">
                          {job.location}
                        </span>
                      </div>

                      <p className="text-gray-600 font-medium">{job.company}</p>

                      <p className="text-sm text-gray-700 mb-4">
                        <span className="font-medium">Skills Required:</span>{" "}
                        {job.requirements}
                      </p>
                    </div>

                    {/* Button always aligned bottom-right */}
                    <div className="flex justify-end mt-4">
                      <button
                        onClick={() =>
                          navigate(`/jobdetails/${job.id}`, { state: { job } })
                        }
                        className="px-4 sm:px-6 bg-[#1e6c8e] text-white py-2 text-sm rounded-lg 
                                hover:bg-[#155a73] transition duration-300"
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                ))}
          </div>

          {!loading && filteredJobs.length === 0 && (
            <div className="bg-white p-8 rounded-lg shadow text-center mt-8">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">
                No jobs found
              </h3>
              <p className="text-gray-500">
                Try changing the filters or come back later.
              </p>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FindJob;


//////////-----------try to add 30 days job valid-----------///////////////////


// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import { db } from "../firebase";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import { Helmet } from "react-helmet";

// // Skeleton loader card
// const JobCardSkeleton = () => (
//   <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
//     <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
//     <div className="flex justify-between items-start mb-3">
//       <div className="h-6 bg-gray-300 rounded w-3/4"></div>
//       <div className="h-5 bg-gray-300 rounded w-12"></div>
//     </div>
//     <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
//     <div className="h-3 bg-gray-300 rounded w-full mb-4"></div>
//     <div className="h-10 bg-gray-300 rounded"></div>
//   </div>
// );

// const FindJob = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [jobs, setJobs] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [locationFilter, setLocationFilter] = useState("");
//   const [categoryFilter, setCategoryFilter] = useState("");
//   const [loading, setLoading] = useState(false);

//   const jobCategories = [
//     "Technology",
//     "Marketing",
//     "Design",
//     "Finance",
//     "Sales",
//     "Human Resources",
//     "Operations",
//     "Customer Service",
//     "Healthcare",
//     "Education",
//   ];

//   // Update category filter based on URL
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const categoryFromURL = params.get("category") || "";
//     setCategoryFilter(categoryFromURL);
//   }, [location.search]);

//   // Fetch jobs from Firestore
//   useEffect(() => {
//     const fetchJobs = async () => {
//       setLoading(true);
//       try {
//         const jobsRef = collection(db, "jobs");

//         const qStatus = query(jobsRef, where("status", "==", "approved"));
//         const qApproved = query(jobsRef, where("approved", "==", true));

//         const [snapStatus, snapApproved] = await Promise.all([
//           getDocs(qStatus),
//           getDocs(qApproved),
//         ]);

//         const combinedDocs = [
//           ...snapStatus.docs,
//           ...snapApproved.docs.filter(
//             (doc) => !snapStatus.docs.some((d) => d.id === doc.id)
//           ),
//         ];

//         // Get current date and calculate cutoff (30 days ago)
//         const now = new Date();
//         const cutoffDate = new Date();
//         cutoffDate.setDate(now.getDate() - 30);

//         const jobsData = combinedDocs
//           .map((d) => ({
//             id: d.id,
//             ...d.data(),
//           }))
//           // Filter jobs posted in the last 30 days
//           .filter((job) => {
//             if (!job.postedDate) return false;
//             const jobDate = job.postedDate?.toDate
//               ? job.postedDate.toDate()
//               : new Date(job.postedDate);
//             return jobDate >= cutoffDate;
//           });

//         // Sort by newest first
//         jobsData.sort((a, b) => {
//           const dateA = a.postedDate?.toDate
//             ? a.postedDate.toDate()
//             : new Date(a.postedDate);
//           const dateB = b.postedDate?.toDate
//             ? b.postedDate.toDate()
//             : new Date(b.postedDate);
//           return dateB - dateA;
//         });

//         setJobs(jobsData);
//       } catch (error) {
//         console.error("Error fetching approved jobs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchJobs();
//   }, []);

//   // Filter jobs based on search, location, and category
//   const filteredJobs = jobs.filter((job) => {
//     const title = (job.title || "").toLowerCase();
//     const company = (job.company || "").toLowerCase();
//     const jobLocation = job.location || "";
//     const jobCategory = job.category || "";

//     const matchesSearch =
//       title.includes(searchTerm.toLowerCase()) ||
//       company.includes(searchTerm.toLowerCase());

//     const matchesLocation =
//       locationFilter === "" || jobLocation === locationFilter;

//     const matchesCategory =
//       categoryFilter === "" || jobCategory === categoryFilter;

//     return matchesSearch && matchesLocation && matchesCategory;
//   });

//   return (
//     <>
//       <Helmet>
//         <title>Find Jobs in Delhi NCR | Browse Latest Openings</title>
//         <meta
//           name="description"
//           content="Search and apply for the latest jobs in Delhi, Noida, and Gurgaon. Browse job categories and filter by company, location, or role. Start your career with JobsInDelhiNCR."
//         />
//       </Helmet>
//       <Navbar />
//       <div className="min-h-screen bg-gray-50 py-10 px-4">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6">
//             {loading ? "Loading Jobs..." : `${filteredJobs.length} Jobs Found`}
//           </h2>

//           {/* Filters */}
//           <div className="bg-white rounded-lg shadow-md p-6 mb-8">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               <input
//                 type="text"
//                 placeholder="Search by job title or company"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={locationFilter}
//                 onChange={(e) => setLocationFilter(e.target.value)}
//               >
//                 <option value="">All Locations</option>
//                 <option value="Delhi">Delhi</option>
//                 <option value="Noida">Noida</option>
//                 <option value="Gurgaon">Gurgaon</option>
//               </select>
//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={categoryFilter}
//                 onChange={(e) => {
//                   const selected = e.target.value;
//                   setCategoryFilter(selected);

//                   const params = new URLSearchParams(location.search);
//                   if (selected) {
//                     params.set("category", selected);
//                   } else {
//                     params.delete("category");
//                   }

//                   navigate({
//                     pathname: "/findjobs",
//                     search: params.toString(),
//                   });
//                 }}
//               >
//                 <option value="">All Categories</option>
//                 {jobCategories.map((category) => (
//                   <option key={category} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Job Cards or Skeletons */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {loading
//               ? [...Array(6)].map((_, i) => <JobCardSkeleton key={i} />)
//               : filteredJobs.map((job) => (
//                   <div
//                     key={job.id}
//                     className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between hover:shadow-lg transition"
//                   >
//                     <div>
//                       <p className="text-sm text-gray-500 mb-2">
//                         Posted on{" "}
//                         {job.postedDate
//                           ? new Date(job.postedDate).toLocaleDateString(
//                               "en-IN",
//                               {
//                                 day: "2-digit",
//                                 month: "short",
//                                 year: "numeric",
//                               }
//                             )
//                           : "N/A"}
//                       </p>

//                       <div className="flex justify-between items-start mb-3">
//                         <h3 className="text-xl font-semibold text-gray-800">
//                           {job.title}
//                         </h3>
//                         <span className="bg-[#F5F5F5] text-red-600 text-sm px-3 py-1 rounded-full font-medium">
//                           {job.location}
//                         </span>
//                       </div>

//                       <p className="text-gray-600 font-medium">{job.company}</p>

//                       <p className="text-sm text-gray-700 mb-4">
//                         <span className="font-medium">Skills Required:</span>{" "}
//                         {job.requirements}
//                       </p>
//                     </div>

//                     {/* Button always aligned bottom-right */}
//                     <div className="flex justify-end mt-4">
//                       <button
//                         onClick={() =>
//                           navigate(`/jobdetails/${job.id}`, { state: { job } })
//                         }
//                         className="px-4 sm:px-6 bg-[#1e6c8e] text-white py-2 text-sm rounded-lg 
//                  hover:bg-[#155a73] transition duration-300"
//                       >
//                         Apply Now
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//           </div>

//           {!loading && filteredJobs.length === 0 && (
//             <div className="bg-white p-8 rounded-lg shadow text-center mt-8">
//               <h3 className="text-lg font-semibold mb-2 text-gray-800">
//                 No jobs found
//               </h3>
//               <p className="text-gray-500">
//                 Try changing the filters or come back later.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default FindJob;





























///pagination

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import { db } from "../firebase";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import { Helmet } from "react-helmet";

// // Skeleton loader card
// const JobCardSkeleton = () => (
//   <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
//     <div className="h-4 bg-gray-300 rounded w-24 mb-2"></div>
//     <div className="flex justify-between items-start mb-3">
//       <div className="h-6 bg-gray-300 rounded w-3/4"></div>
//       <div className="h-5 bg-gray-300 rounded w-12"></div>
//     </div>
//     <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
//     <div className="h-3 bg-gray-300 rounded w-full mb-4"></div>
//     <div className="h-10 bg-gray-300 rounded"></div>
//   </div>
// );

// const FindJob = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [jobs, setJobs] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [locationFilter, setLocationFilter] = useState("");
//   const [categoryFilter, setCategoryFilter] = useState("");
//   const [loading, setLoading] = useState(false);

//   // 🆕 Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const jobsPerPage = 15;

//   const jobCategories = [
//     "Technology",
//     "Marketing",
//     "Design",
//     "Finance",
//     "Sales",
//     "Human Resources",
//     "Operations",
//     "Customer Service",
//     "Healthcare",
//     "Education",
//   ];

//   // Update category filter from URL
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const categoryFromURL = params.get("category") || "";
//     setCategoryFilter(categoryFromURL);
//   }, [location.search]);

//   // Fetch jobs from Firestore
//   useEffect(() => {
//     const fetchJobs = async () => {
//       setLoading(true);
//       try {
//         const jobsRef = collection(db, "jobs");

//         const qStatus = query(jobsRef, where("status", "==", "approved"));
//         const qApproved = query(jobsRef, where("approved", "==", true));

//         const [snapStatus, snapApproved] = await Promise.all([
//           getDocs(qStatus),
//           getDocs(qApproved),
//         ]);

//         const combinedDocs = [
//           ...snapStatus.docs,
//           ...snapApproved.docs.filter(
//             (doc) => !snapStatus.docs.some((d) => d.id === doc.id)
//           ),
//         ];

//         const jobsData = combinedDocs.map((d) => ({
//           id: d.id,
//           ...d.data(),
//         }));

//         // Sort newest first
//         jobsData.sort((a, b) => {
//           const dateA = a.postedDate?.toDate
//             ? a.postedDate.toDate()
//             : new Date(a.postedDate);
//           const dateB = b.postedDate?.toDate
//             ? b.postedDate.toDate()
//             : new Date(b.postedDate);
//           return dateB - dateA;
//         });

//         setJobs(jobsData);
//       } catch (error) {
//         console.error("Error fetching approved jobs:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchJobs();
//   }, []);

//   // Filter jobs
//   const filteredJobs = jobs.filter((job) => {
//     const title = (job.title || "").toLowerCase();
//     const company = (job.company || "").toLowerCase();
//     const jobLocation = job.location || "";
//     const jobCategory = job.category || "";

//     const matchesSearch =
//       title.includes(searchTerm.toLowerCase()) ||
//       company.includes(searchTerm.toLowerCase());

//     const matchesLocation =
//       locationFilter === "" ||
//       jobLocation.toLowerCase().includes(locationFilter.toLowerCase());

//     const matchesCategory =
//       categoryFilter === "" || jobCategory === categoryFilter;

//     return matchesSearch && matchesLocation && matchesCategory;
//   });

//   // 🆕 Pagination logic
//   const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
//   const indexOfLastJob = currentPage * jobsPerPage;
//   const indexOfFirstJob = indexOfLastJob - jobsPerPage;
//   const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top on page change
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Find Jobs in Delhi NCR | Browse Latest Openings</title>
//         <meta
//           name="description"
//           content="Search and apply for the latest jobs in Delhi, Noida, and Gurugram. Browse job categories and filter by company, location, or role. Start your career with JobsInDelhiNCR."
//         />
//       </Helmet>

//       <Navbar />
//       <div className="min-h-screen bg-gray-50 py-10 px-4">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6">All Jobs</h2>

//           {/* Filters */}
//           <div className="bg-white rounded-lg shadow-md p-6 mb-8">
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               <input
//                 type="text"
//                 placeholder="Search by job title or company"
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />

//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={locationFilter}
//                 onChange={(e) => setLocationFilter(e.target.value)}
//               >
//                 <option value="">All Locations</option>
//                 <option value="Delhi">Delhi</option>
//                 <option value="Noida">Noida</option>
//                 <option value="Gurugram">Gurugram</option>
//                 <option value="Faridabad">Faridabad</option>
//                 <option value="Ghaziabad">Ghaziabad</option>
//               </select>

//               <select
//                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 value={categoryFilter}
//                 onChange={(e) => {
//                   const selected = e.target.value;
//                   setCategoryFilter(selected);
//                   const params = new URLSearchParams(location.search);
//                   if (selected) params.set("category", selected);
//                   else params.delete("category");
//                   navigate({
//                     pathname: "/findjobs",
//                     search: params.toString(),
//                   });
//                 }}
//               >
//                 <option value="">All Categories</option>
//                 {jobCategories.map((category) => (
//                   <option key={category} value={category}>
//                     {category}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Job Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {loading
//               ? [...Array(6)].map((_, i) => <JobCardSkeleton key={i} />)
//               : currentJobs.map((job) => (
//                   <div
//                     key={job.id}
//                     className="bg-white rounded-lg shadow-md p-6 flex flex-col justify-between hover:shadow-lg transition"
//                   >
//                     <div>
//                       <p className="text-sm text-gray-500 mb-2">
//                         Posted on{" "}
//                         {job.postedDate
//                           ? new Date(job.postedDate).toLocaleDateString("en-IN", {
//                               day: "2-digit",
//                               month: "short",
//                               year: "numeric",
//                             })
//                           : "N/A"}
//                       </p>

//                       <div className="flex justify-between items-start mb-3">
//                         <h3 className="text-xl font-semibold text-gray-800">
//                           {job.title}
//                         </h3>
//                         <span className="bg-[#F5F5F5] text-red-600 text-sm px-3 py-1 rounded-full font-medium">
//                           {job.location}
//                         </span>
//                       </div>

//                       <p className="text-gray-600 font-medium">{job.company}</p>

//                       <p className="text-sm text-gray-700 mb-4">
//                         <span className="font-medium">Skills Required:</span>{" "}
//                         {job.requirements}
//                       </p>
//                     </div>

//                     <div className="flex justify-end mt-4">
//                       <button
//                         onClick={() =>
//                           navigate(`/jobdetails/${job.id}`, { state: { job } })
//                         }
//                         className="px-4 sm:px-6 bg-[#1e6c8e] text-white py-2 text-sm rounded-lg hover:bg-[#155a73] transition duration-300"
//                       >
//                         Apply Now
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//           </div>

//           {/* 🆕 Pagination controls */}
//           {!loading && filteredJobs.length > 15 && (
//             <div className="flex justify-center mt-8 space-x-2">
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 className="px-4 py-2 border rounded disabled:opacity-50"
//               >
//                 Prev
//               </button>

//               {[...Array(totalPages)].map((_, i) => (
//                 <button
//                   key={i}
//                   onClick={() => handlePageChange(i + 1)}
//                   className={`px-3 py-1 border rounded ${
//                     currentPage === i + 1
//                       ? "bg-blue-500 text-white"
//                       : "bg-white text-gray-700"
//                   }`}
//                 >
//                   {i + 1}
//                 </button>
//               ))}

//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 className="px-4 py-2 border rounded disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           )}

//           {/* No results */}
//           {!loading && filteredJobs.length === 0 && (
//             <div className="bg-white p-8 rounded-lg shadow text-center mt-8">
//               <h3 className="text-lg font-semibold mb-2 text-gray-800">
//                 No jobs found
//               </h3>
//               <p className="text-gray-500">
//                 Try changing the filters or come back later.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default FindJob;
